import { render, staticRenderFns } from "./TriangleCentersViz.vue?vue&type=template&id=ab9969f2&scoped=true"
import script from "./TriangleCentersViz.vue?vue&type=script&lang=js"
export * from "./TriangleCentersViz.vue?vue&type=script&lang=js"
import style0 from "./TriangleCentersViz.vue?vue&type=style&index=0&id=ab9969f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9969f2",
  null
  
)

export default component.exports